import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Card, CardBody, Text } from '@change/ds-core-ui';
import { SelectionCard, SelectionCardGroup } from '@change/ds-forms';

import { Translate } from '@change-corgi/core-react/i18n';

import type { PaymentType } from '#src/app/shared/utils/payments';

import { usePaymentMethodSelectorWrapper } from './hooks/usePaymentMethodSelectorWrapper';

export const PaymentMethodSelectorWrapper: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const {
		data: { availablePaymentMethods, selectedPaymentType },
		actions: { setSelectedPaymentType },
	} = usePaymentMethodSelectorWrapper();

	return (
		<Card className="w-full max-w-[500px]">
			<CardBody className="flex flex-col gap-4">
				<Text id="payment-method-selector-heading" className="uppercase" as="h3" size="medium" fontWeight="bold">
					<Translate value="fe.components.credit_card.payment_method" />
				</Text>

				{availablePaymentMethods.length > 1 && (
					<SelectionCardGroup
						label=""
						labelIsVisible={false}
						name="paymentMethod"
						value={selectedPaymentType}
						onChange={(value) => setSelectedPaymentType(value as PaymentType)}
						variant="compact"
						aria-labelledby="payment-method-selector-heading"
					>
						{availablePaymentMethods.map((paymentMethod) => (
							<div data-qa={`payment-method-${paymentMethod.type}`} key={paymentMethod.type}>
								<SelectionCard
									value={paymentMethod.type}
									slot={
										<div className="flex flex-col items-center justify-center text-center">
											{paymentMethod.iconDark ? (
												<>
													<img src={paymentMethod.icon} alt={paymentMethod.label} className="dark:hidden" />
													<img src={paymentMethod.iconDark} alt={paymentMethod.label} className="hidden dark:inline" />
												</>
											) : (
												<img src={paymentMethod.icon} alt={paymentMethod.label} />
											)}
											<Text size="small">{paymentMethod.label}</Text>
										</div>
									}
								/>
							</div>
						))}
					</SelectionCardGroup>
				)}
				{children}
			</CardBody>
		</Card>
	);
};
